<template>
  <div class="member-management-container">
    <h2>会员管理</h2>
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>用户名</th>
          <th>审核状态</th>
          <th>是否锁定</th>
          <th>手机号</th>
          <th>有效期</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(member, index) in paginatedMembers" :key="member.id" :class="{ 'even-row': index % 2 === 0 }">
          <td>{{ member.id }}</td>
          <td>{{ member.username }}</td>
          <td>
            <label class="switch">
              <input
                type="checkbox"
                :checked="member.is_active === 1"
                @change="changeStatus(member.id, member.is_active === 1 ? 0 : 1)"
              />
              <span class="slider round"></span>
            </label>
          </td>
           <td>
            <label class="switch">
              <input
                type="checkbox"
                :checked="member.is_locked === 1"
                @change="changeLocked(member.id, member.is_locked === 1 ? 0 : 1)"
              />
              <span class="slider round"></span>
            </label>
          </td>
          <td>
            <input
              type="text"
              v-model="member.mobile"
              @blur="saveMobile(member.id, member.mobile)"
            />
          </td>
          <td>
            <el-date-picker
              v-model="member.expiration_date"
              type="date"
              placeholder="选择有效期"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
            />
          </td>
          <td>
            <button @click="saveExpiry(member.id, member.expiration_date)">保存</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pagination">
      <button @click="prevPage" :disabled="currentPage === 1">上一页</button>
      <span>{{ currentPage }} / {{ totalPages }}</span>
      <button @click="nextPage" :disabled="currentPage === totalPages">下一页</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      members: [],
      currentPage: 1,
      pageSize: 10
    };
  },
  computed: {
    paginatedMembers() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.members.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.members.length / this.pageSize);
    }
  },
  methods: {
    async fetchMembers() {
      try {
        const response = await axios.get('/api/member', {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
          },
          params: {
            page: this.currentPage,
            size: this.pageSize
          }
        });
        // 确保 response.data 是一个数组
        if (Array.isArray(response.data)) {
          this.members = response.data.map(member => ({
            ...member,
            expiration_date: this.formatDate(member.expiration_date)
          }));
        } else if (response.data && Array.isArray(response.data.data)) {
          this.members = response.data.data.map(member => ({
            ...member,
            expiration_date: this.formatDate(member.expiration_date)
          }));
        } else {
          console.error('API 返回的数据格式不正确:', response.data);
          this.members = [];
        }
        console.log(this.members);
      } catch (error) {
        console.error('获取会员信息错误:', error);
        this.members = [];
      }
    },
    formatDate(date) {
      if (!date) return '';
      const [fullDate] = date.split(' '); // 取日期部分，去掉时间部分
      return fullDate;
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchMembers();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchMembers();
      }
    },
    async changeStatus(id, newStatus) {
      try {
        const response = await axios.put(`/api/member/${id}/status`, { new_status: newStatus }, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
          }
        });

        alert(response.data.message);

        this.fetchMembers();
      } catch (error) {
        console.error('更改用户状态错误:', error);
      }
    },
     async changeLocked(id, newStatus) {
      try {
        const response = await axios.put(`/api/member/${id}/locked`, { new_status: newStatus }, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
          }
        });

        alert(response.data.message);

        this.fetchMembers();
      } catch (error) {
        console.error('更改用户状态错误:', error);
      }
    },
    async saveExpiry(id, newExpiryDate) {
      try {
        const response = await axios.put(`/api/member/${id}/expiry`, {
          expiry: newExpiryDate
        }, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
          }
        });
        alert(response.data.message);
        this.fetchMembers();
      } catch (error) {
        console.error('更改用户有效期错误:', error);
      }
    },
    async saveMobile(id, newMobile) {
      try {
        const response = await axios.put(`/api/member/${id}/mobile`, {
          mobile: newMobile
        }, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
          }
        });
        alert(response.data.message);
        this.fetchMembers();
      } catch (error) {
        console.error('更改用户手机号错误:', error);
      }
    }
  },
  mounted() {
    this.fetchMembers();
  }
};
</script>

<style scoped>
.member-management-container {
  padding: 20px;
  background-color: #f9f9f9;
}

h2 {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
}

th, td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #333;
}

tr.even-row {
  background-color: #f9f9f9;
}

tr:hover {
  background-color: #f1f1f1;
}

button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #0056b3;
}

button:disabled {

  background-color: #ccc;
  cursor: not-allowed;
}

input[type="text"] {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination button {
  margin: 0 5px;
  padding: 10px 15px;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.pagination button:hover {
  background-color: #0056b3;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination span {
  font-size: 18px;
  margin: 0 10px;
  color: #333;
}

/* 开关样式 */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
